import { Link } from "react-router-dom";
import { DropdownMenu, Icon, Typography } from "@/components/atoms";
import { FleetDriver } from "@/redux/slices/driver/types";
import { renderFleetAvatar } from "../MyDrivers/MyDrivers/helpers";
import { ArchivedDriversTableData } from "./types";

const archivedStatusDisplayMap: Record<string, string> = {
  removed: "Terminated",
  left: "Left",
  Declined: "Decline",
  "Permanently Terminated": "Terminated",
  Retired: "Left",
};

export const generateArchivedDriversTableData = (
  items: FleetDriver[],
  onUndoTermination: (driverId: string) => void,
  onUndoDriverLeft: (driverId: string) => void
) => {
  const data = items.map(
    (i) =>
      ({
        name: renderDriverName(i),
        email: i.email,
        mobile: i.phone,
        status: renderArchivedStatus(i.status),
        reason: i.statusNote,
        action: renderArchivedDriverActions(i, onUndoTermination, onUndoDriverLeft),
      } as ArchivedDriversTableData)
  );

  return data;
};

const renderDriverName = (driver: FleetDriver) => {
  return (
    <Link to={driver.uuid}>
      <div className="flex flex-row items-center gap-2.5 hover:text-info">
        {renderFleetAvatar(driver.avatar, driver.name, driver.isFleetLeader)}
        <Typography variant="paragraph">{driver.name}</Typography>
      </div>
    </Link>
  );
};

const renderArchivedStatus = (status: string) => {
  const displayLabel = archivedStatusDisplayMap[status] ?? status;

  return (
    <Typography variant="paragraph" className="flex flex-row items-center gap-2">
      <span className="h-2 w-2 flex-shrink-0 rounded-full bg-danger" /> {displayLabel}
    </Typography>
  );
};

const isTerminatedStatus = (status: string) =>
  ["removed", "Permanently Terminated"].includes(status);

const isLeftStatus = (status: string) =>
  ["left", "Retired"].includes(status);

const renderArchivedDriverActions = (
  driver: FleetDriver,
  onUndoTermination: (driverId: string) => void,
  onUndoDriverLeft: (driverId: string) => void
) => {
  const isTerminated = isTerminatedStatus(driver.status);
  const isLeft = isLeftStatus(driver.status);

  return (
    <DropdownMenu button={<Icon name="options" isCustom size="lg" />} position="bottom-start" className="!flex max-w-[24px]">
      <Link to={driver.uuid}>
        <DropdownMenu.Item>
          <Icon name="UserSquare" size="sm" className="mr-2.5" />
          <Typography variant="paragraph">View Driver</Typography>
        </DropdownMenu.Item>
      </Link>
      {isTerminated && (
        <DropdownMenu.Item onClick={() => onUndoTermination(driver.uuid)}>
          <Icon name="Refresh2" size="sm" className="mr-2.5" />
          <Typography variant="paragraph">Undo Termination</Typography>
        </DropdownMenu.Item>
      )}
      {isLeft && (
        <DropdownMenu.Item onClick={() => onUndoDriverLeft(driver.uuid)}>
          <Icon name="Refresh2" size="sm" className="mr-2.5" />
          <Typography variant="paragraph">Undo Driver Has Left</Typography>
        </DropdownMenu.Item>
      )}
    </DropdownMenu>
  );
};
